export default __webpack_public_path__ + "static/media/no_image_photo.b93c0dda.svg";